import React, { useState } from 'react';
import { QuestionInputProps, QuestionSendIconProps } from './types/questions';
import { addAudienceQuestion } from './api';
import '../base.scss';
import QuestionNotification from './notification';
import classNames from 'classnames';
import { useAppSyncProvider } from 'components/AppSyncProvider';

export const QuestionSendIcon = ({
  className = 'QuestionSendIcon',
  size = 35,
}: Readonly<QuestionSendIconProps>) => {
  return (
    <svg
      className={className}
      focusable="false"
      viewBox="0 0 35 35"
      aria-label="Send chat message"
      height={`${size}px`}
      width={`${size}px`}
    >
      <circle
        className={`${className}__Background`}
        cx="17.5"
        cy="17.5"
        r="17.5"
      />
      <path
        className={`${className}__Arrow`}
        d="M6.775 17.607l8.531 1.994 2.7 8.457 6.545-17.576z"
      />
    </svg>
  );
};

export const AudienceQuestion = ({ setNotification }: QuestionInputProps) => {
  const [question, setQuestion] = useState('');
  const { client } = useAppSyncProvider();
  const submitAudienceQuestion = async () => {
    setNotification({ status: 'Sending', message: 'Sending...' });
    try {
      const res = await addAudienceQuestion(question, client);
      if (!res) {
        throw new Error('Failed to send');
      }
      setQuestion('');
      setNotification({
        status: 'Success',
        message: 'Question sent!',
      });

      setTimeout(() => {
        setNotification({ status: 'Hidden', message: '' });
      }, 5000);
    } catch (e) {
      console.error(e);
      setNotification({
        status: 'Error',
        message:
          'Whoops,seems an error occured while sending you question. Please try again!',
      });
      setTimeout(() => {
        setNotification({ status: 'Hidden', message: '' });
      }, 5000);
    }
  };
  const handleKey = (
    evt: React.KeyboardEvent<HTMLTextAreaElement | HTMLDivElement>,
  ) => {
    if (evt.key === 'Enter') {
      evt.preventDefault();
      console.log('pressed');
      submitAudienceQuestion();
    }
  };

  return (
    <div className="Audience_Question">
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          submitAudienceQuestion();
        }}
        className="Audience_Question__Form"
      >
        <input
          data-testid="audience-question-input"
          className="Audience_Question__Input"
          onKeyPress={handleKey}
          onChange={(e) => setQuestion(e.target.value)}
          spellCheck
          maxLength={155}
          aria-label="AudienceQuestion"
          placeholder={'Ask a question..'}
          value={question}
        />
        <button
          className="Audience_Question__Submit"
          data-testid="question-submit"
          type="submit"
          disabled={!question}
        >
          <QuestionSendIcon />
        </button>
      </form>
    </div>
  );
};

export const AudienceQuestionModal = () => {
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState({
    status: 'Hidden',
    message: '',
  });

  return (
    <>
      <QuestionNotification
        notification={notification}
        setNotification={setNotification}
      />
      <div
        data-testid="question-modal"
        className={classNames('Question', {
          'Question--open': open,
        })}
      >
        <button
          className="Question__ModalTrigger"
          data-testid="question-modaltrigger"
          onClick={() => setOpen(!open)}
        >
          Questions
        </button>
        <div
          className={classNames('Question__Modal', {
            'Question__Modal--visible': open,
          })}
        >
          <AudienceQuestion setNotification={setNotification} />
          <button
            id="question-close"
            data-testid="close-modal"
            className="Question__Modal__Close"
            onClick={() => setOpen(false)}
          >
            x
          </button>
        </div>
      </div>
    </>
  );
};
